import * as React from 'react';

import UserAvatar from 'users/components/UserAvatar';
import { Props as UserAvatarProps } from 'users/components/UserAvatar';

import getField from '../ComposableTableField';
import { Field } from '../ComposableTableField';

export function getUserAvatarCellGenerator<T>(input: {
  fieldForAction?: Field<T>,
  userField?: Field<T>,
  onClickAction?: (event: React.SyntheticEvent, user: T) => void,
  userAvatarProps?: Partial<UserAvatarProps>,
}) {
  return (data: T) => {
    const { fieldForAction, onClickAction, userAvatarProps, userField } = input;

    return (
      <UserAvatar
        {...userAvatarProps}
        user={getField(data, userField ?? null)}
        size="medium"
        onClick={(e) => {onClickAction && onClickAction(e, getField(data, fieldForAction ?? null))}}
      />
    );
  };
}
